import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import useStore from "../store";
import { Empty, Skeleton } from "antd";
import { ZFormRefresh, ZFormCollapseDown, ZFormCollapseUp } from "../config/IconsConfig";
import ActiveFinanceStructure from "./ActiveFinanceStructure";


const ActiveFinance = observer((props) => {
	const { WidgetStore } = useStore()
	const [isOpen, setIsOpen] = useState(true)
	const [loading, setLoading] = useState(false)


	useEffect(() => {
		if (props.api_url && !WidgetStore.list_inquiries_by_status) {
			setLoading(true)

			WidgetStore.getActiveFinaceList(props.api_url, "list_active_finance").then((data) => {
				setLoading(false);
			}).catch((e) => {
				setLoading(false)
			})
		}
	}, [props, WidgetStore])

	const handleReSync = () => {
		setLoading(true)
		WidgetStore.getActiveFinaceList(props.api_url, "list_active_finance").then((data) => {
			setLoading(false)
		})
			.catch((e) => {
				setLoading(false)
			})
			.finally(() => setLoading(false));
	}


	return (
		<div className="dashboard_widget_block">
			<div className="widget_title">
				<h3>{props.title}</h3>
				<div className="refresh_toggle_icon">

					<ZFormRefresh className="mr-15" onClick={handleReSync} />
					{isOpen ? <ZFormCollapseDown onClick={() => setIsOpen(!isOpen)} /> : <ZFormCollapseUp onClick={() => setIsOpen(!isOpen)} />}
				</div>
			</div>
			<div style={{ maxHeight: isOpen ? "999px" : "0" }} className="widget_wrapper">
				{
					loading ?
						<Skeleton active />
						:
						WidgetStore.list_active_finance ?
							<>
								<ul className="widget_data active_finance_widget">
									<ActiveFinanceStructure
										title={"Quotations"}
										className={"blueRow"}
										redirectLink={"/finance/irr"}
										filterValue={"Quote In progress"}
										count={WidgetStore.list_active_finance.quotation}
									/>
									<ActiveFinanceStructure
										title={"Approval"}
										className={"greenRow"}
										redirectLink={"/finance/irr"}
										filterValue={"Pending Approval"}
										count={WidgetStore.list_active_finance.approval}
									/>
									<ActiveFinanceStructure
										title={"Processing"}
										className={"orangeRow"}
										redirectLink={"/finance/irr"}
										listType="Processing"
										count={WidgetStore.list_active_finance.processing}
									/>
								</ul>
							</>
							: <Empty />
				}
			</div>
		</div>
	)
})

export default ActiveFinance
